import React, { useState, useEffect } from 'react';

// Building Detail Component
function BuildingDetail({ building, onBack, apiBaseUrl }) {
  const [selectedFloor, setSelectedFloor] = useState(null);
  const [floorImage, setFloorImage] = useState(null);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [imageModal, setImageModal] = useState({
    isOpen: false,
    imageUrl: '',
    title: ''
  });

  useEffect(() => {
    if (building.floors && building.floors.length > 0) {
      // Eğer seçilen kat varsa onu kullan, yoksa ilk katı kullan
      const targetFloor = building.selectedFloor || building.floors[0];
      setSelectedFloor(targetFloor);
      
      // Load target floor image if available
      if (building.has_kroki && targetFloor) {
        let imageName = null;
        let imageUrl = null;
        
        // Önce yeni görselleri dene
        if (building.has_new_images && building.floor_mappings_new) {
          imageName = building.floor_mappings_new[targetFloor];
          if (imageName) {
            const folderName = getBuildingFolderName(building.building_name);
            // URL encode yap
            const encodedFolderName = encodeURIComponent(folderName);
            const encodedImageName = encodeURIComponent(imageName);
            imageUrl = `${apiBaseUrl.replace('/api', '')}/static/buildings_new/${encodedFolderName}/${encodedImageName}?v=${Date.now()}&cache=${Math.random()}`;
            console.log('🆕 YENİ GÖRSEL KULLANILIYOR:', imageUrl, 'for floor:', targetFloor, 'building:', building.building_name, 'folder:', folderName);
          } else {
            console.log('❌ Yeni görsel bulunamadı for floor:', targetFloor, 'in building:', building.building_name);
          }
        } else {
          console.log('❌ Yeni görseller aktif değil. has_new_images:', building.has_new_images, 'floor_mappings_new:', building.floor_mappings_new);
        }
        
        // Yeni görsel yoksa eski görseli kullan
        if (!imageName && building.floor_mappings) {
          imageName = building.floor_mappings[targetFloor];
          if (imageName) {
            const folderName = getBuildingFolderName(building.building_name);
            // URL encode yap
            const encodedFolderName = encodeURIComponent(folderName);
            const encodedImageName = encodeURIComponent(imageName);
            imageUrl = `${apiBaseUrl.replace('/api', '')}/static/buildings/${encodedFolderName}/${encodedImageName}?v=${Date.now()}`;
            console.log('🔄 ESKİ GÖRSEL KULLANILIYOR:', imageUrl, 'for floor:', targetFloor, 'building:', building.building_name, 'folder:', folderName);
          }
        }
        
        if (imageUrl) {
          setFloorImage(imageUrl);
        } else {
          console.log('Image name not found for target floor:', targetFloor);
          setFloorImage(null);
        }
      } else {
        console.log('Building has_kroki:', building.has_kroki);
        console.log('Building floor_mappings:', building.floor_mappings);
        console.log('Target floor:', targetFloor);
      }
    }
  }, [building, apiBaseUrl]);

  // Function to map building names to folder names
  const getBuildingFolderName = (buildingName) => {
    const folderMapping = {
      'Rektörlük Binası': 'Rektörlük_Binası',
      'Mühendislik Fakültesi': 'Mühendislik_Fakültesi',
      'Sağlık Bilimleri Fakültesi': 'Sağlık_Bilimleri_Fakültesi',
      'Diş Hekimliği Fakültesi': 'Diş_Hekimliği_Fakültesi',
      'Meslek Yüksekokulu': 'Meslek_Yüksekokulu',
      'Fantom ve Prakilinik Laboratuvarı': 'Fantom_ve_Prakilinik_Laboratuvarı',
      'Etkinlik Alanı': 'Etkinlik_Alanı',
      'Kafeterya': 'Kafeterya',
      'Kütüphane': 'Kütüphane',
      'Spor Salonu': 'Spor_Salonu'
    };
    return folderMapping[buildingName] || buildingName.replace(/ /g, '_');
  };

  // Oda görselini almak için yardımcı fonksiyon
  const getRoomImageUrl = (roomName) => {
    // Oda adından dosya adı oluştur (Türkçe karakterler dahil)
    // ÖNEMLİ: & karakterini önce 've' ile değiştir, sonra diğer karakterleri _ ile değiştir
    const baseFileName = roomName
      .toLowerCase()
      .replace(/&/g, 've')
      .replace(/[^a-z0-9çğıöşü]/g, '_')
      .replace(/\//g, '_')
      .replace(/_+/g, '_')
      .replace(/^_|_$/g, '');
    
    // apiBaseUrl'den /api kısmını çıkar
    const baseUrl = apiBaseUrl.replace('/api', '');
    
    // Önce optimize edilmiş derslik görsellerini dene (.png uzantısı ile)
    let imageUrl = `${baseUrl}/static/room_images_optimized/${baseFileName}.png`;
    
    console.log('🆕 OPTİMİZE EDİLMİŞ DERSLİK GÖRSELİ DENENİYOR (.png):', imageUrl, 'for room:', roomName, 'fileName:', baseFileName);
    
    // Eğer yeni görsel yoksa eski görseli kullan
    // Bu kontrol frontend'de yapılacak (onError ile)
    return imageUrl;
  };

  // Oda görseline tıklama fonksiyonu
  const handleImageClick = (roomName) => {
    const imageUrl = getRoomImageUrl(roomName);
    setImageModal({
      isOpen: true,
      imageUrl: imageUrl,
      title: roomName
    });
  };

  // Modal kapatma fonksiyonu
  const closeImageModal = () => {
    setImageModal({
      isOpen: false,
      imageUrl: '',
      title: ''
    });
  };

  const handleFloorSelect = (floorName, floorIndex) => {
    setSelectedFloor(floorName);
    setSelectedRoom(null); // Reset selected room when floor changes
    
    // Load floor image if available
    if (building.has_kroki) {
      let imageName = null;
      let imageUrl = null;
      
      // Önce yeni görselleri dene
      if (building.has_new_images && building.floor_mappings_new) {
        imageName = building.floor_mappings_new[floorName];
        if (imageName) {
          const folderName = getBuildingFolderName(building.building_name);
          imageUrl = `${apiBaseUrl.replace('/api', '')}/static/buildings_new/${encodeURIComponent(folderName)}/${encodeURIComponent(imageName)}?v=${Date.now()}`;
          console.log('🆕 YENİ FLOOR GÖRSEL KULLANILIYOR:', imageUrl, 'for floor:', floorName, 'building:', building.building_name, 'folder:', folderName);
        } else {
          console.log('❌ Yeni floor görsel bulunamadı for floor:', floorName, 'in building:', building.building_name);
        }
      } else {
        console.log('❌ Yeni floor görseller aktif değil. has_new_images:', building.has_new_images, 'floor_mappings_new:', building.floor_mappings_new);
      }
      
      // Yeni görsel yoksa eski görseli kullan
      if (!imageName && building.floor_mappings) {
        imageName = building.floor_mappings[floorName];
        if (imageName) {
          const folderName = getBuildingFolderName(building.building_name);
          imageUrl = `${apiBaseUrl.replace('/api', '')}/static/buildings/${encodeURIComponent(folderName)}/${encodeURIComponent(imageName)}?v=${Date.now()}`;
          console.log('🔄 ESKİ FLOOR GÖRSEL KULLANILIYOR:', imageUrl, 'for floor:', floorName, 'building:', building.building_name, 'folder:', folderName);
        }
      }
      
      if (imageUrl) {
        setFloorImage(imageUrl);
      } else {
        console.log('Image name not found for floor:', floorName);
        setFloorImage(null);
      }
    }
  };

  return (
    <div className="building-detail-new">
      {/* Header Section */}
      <div className="detail-header">
        <div className="header-left">
          <button className="back-btn" onClick={onBack}>
            <span className="back-icon">←</span>
            <span>Geri Dön</span>
          </button>
        </div>
        <div className="header-center">
          <div className="building-title">
            <h1>{building.building_name}</h1>
            <p className="building-subtitle">{building.description}</p>
          </div>
        </div>
        <div className="header-right">
          <div className="building-logo">
            <img 
              src="/PHOTO-2025-08-08-10-35-33-Photoroom.png" 
              alt="KOSTÜ Logo"
              className="logo-image"
            />
          </div>
          <div className="building-stats">
            <div className="stat-item">
              <span className="stat-icon">🏢</span>
              <span className="stat-value">{building.floors?.length || 0}</span>
              <span className="stat-label">Kat</span>
            </div>
            <div className="stat-item">
              <span className="stat-icon">🚪</span>
              <span className="stat-value">{building.rooms?.total_rooms || 0}</span>
              <span className="stat-label">Oda</span>
            </div>
            <div className="stat-item">
              <span className="stat-icon">📋</span>
              <span className="stat-value">{building.has_kroki ? '✅' : '❌'}</span>
              <span className="stat-label">Kroki</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="detail-main">
        {/* Kat Seçimi - Üstte */}
        <div className="floor-selection-panel">
          <h3 className="section-title">
            <span className="title-icon">🏢</span>
            Kat Seçimi
          </h3>
          <div className="floor-grid">
            {building.floors?.map((floor, index) => (
              <button
                key={index}
                className={`floor-card ${selectedFloor === floor ? 'active' : ''}`}
                onClick={() => handleFloorSelect(floor, index)}
              >
                <div className="floor-number">{floor === 'Zemin Kat' ? '0' : floor === '-1. Kat' ? '-1' : floor === '1. Kat' ? '1' : floor === '2. Kat' ? '2' : floor === '3. Kat' ? '3' : floor === 'Çatı Katı' ? 'Ç' : floor === 'Konferans Salonu' ? 'K' : floor === 'Ana Alan' ? 'A' : String(index + 1)}</div>
                <div className="floor-name">{floor}</div>
              </button>
            ))}
          </div>
        </div>

        {/* Oda Listesi ve Kroki - Yan Yana */}
        <div className="floor-content-container">
          {/* Sol Taraf - Oda Listesi */}
          <div className="room-list-panel">
            {selectedFloor && building.rooms?.floors.find(f => f.floor_name === selectedFloor) ? (
              <div className="room-list-section">
                <h3 className="section-title">
                  <span className="title-icon">🚪</span>
                  {selectedFloor} Odaları
                </h3>
                <div className="room-list">
                  {(() => {
                    const currentFloor = building.rooms?.floors.find(f => f.floor_name === selectedFloor);
                    console.log('Current floor:', currentFloor);
                    console.log('Selected floor:', selectedFloor);
                    
                    if (!currentFloor || !currentFloor.rooms) {
                      return <p>Bu kat için oda bilgisi bulunamadı.</p>;
                    }
                    
                    return currentFloor.rooms.map((room, index) => (
                      <div key={index} className="room-item-container">
                        <button
                          className={`room-item ${selectedRoom?.room_number === room.room_number ? 'active expanded' : ''}`}
                          onClick={() => setSelectedRoom(selectedRoom?.room_number === room.room_number ? null : room)}
                        >
                          <div className="room-item-main">
                            <div className="room-item-header">
                              <span className="room-item-name">{room.room_name}</span>
                              <span className="room-item-number">{room.room_number}</span>
                            </div>
                            <div className="room-item-details">
                              <span className="room-item-type">{room.room_type}</span>
                              <span className="room-item-area">{room.area_sqm} m²</span>
                            </div>
                          </div>
                          
                          {/* Oda Detayları - Butonun İçinde */}
                          {selectedRoom?.room_number === room.room_number && (
                            <div className="room-detail-expanded">
                              {/* Oda Görseli */}
                              <div className="room-image-container">
                                <img 
                                  src={getRoomImageUrl(room.room_name)}
                                  alt={room.room_name}
                                  className="room-image clickable"
                                  onClick={() => handleImageClick(room.room_name)}
                                  onError={(e) => {
                                    console.log('❌ PC OPTİMİZE EDİLMİŞ derslik görseli yüklenemedi (.png):', e.target.src);
                                    // Optimize edilmiş görsel yüklenemezse önce .jpg dene, sonra eski görseli dene
                                    const baseUrl = apiBaseUrl.replace('/api', '');
                                    const baseFileName = room.room_name
                                      .toLowerCase()
                                      .replace(/&/g, 've')
                                      .replace(/[^a-z0-9çğıöşü]/g, '_')
                                      .replace(/\//g, '_')
                                      .replace(/_+/g, '_')
                                      .replace(/^_|_$/g, '');
                                    
                                    // Önce optimize edilmiş .jpg dene
                                    const optimizedJpgUrl = `${baseUrl}/static/room_images_optimized/${baseFileName}.jpg`;
                                    console.log('🔄 PC OPTİMİZE EDİLMİŞ DERSLİK GÖRSELİ DENENİYOR (.jpg):', optimizedJpgUrl);
                                    
                                    // .jpg yüklenemezse eski görseli dene
                                    const oldImage = new Image();
                                    oldImage.onload = () => {
                                      console.log('✅ PC ESKİ DERSLİK GÖRSELİ YÜKLENDİ:', oldImage.src);
                                      e.target.src = oldImage.src;
                                    };
                                    oldImage.onerror = () => {
                                      console.log('❌ PC ESKİ DERSLİK GÖRSELİ DE YÜKLENEMEDİ');
                                    };
                                    oldImage.src = optimizedJpgUrl;
                                  }}
                                  onLoad={(e) => {
                                    console.log('✅ PC Derslik görseli yüklendi:', e.target.src);
                                  }}
                                />
                              </div>
                              <div className="room-detail-content">
                                <div className="detail-row">
                                  <span className="detail-label">Tip:</span>
                                  <span className="detail-value">{room.room_type}</span>
                                </div>
                                <div className="detail-row">
                                  <span className="detail-label">Alan:</span>
                                  <span className="detail-value">{room.area_sqm} m²</span>
                                </div>
                                <div className="detail-row">
                                  <span className="detail-label">Kapasite:</span>
                                  <span className="detail-value">{room.capacity === 0 ? 'Belirtilmemiş' : `${room.capacity} kişi`}</span>
                                </div>
                              </div>
                            </div>
                          )}
                        </button>
                      </div>
                    ));
                  })()}
                </div>
              </div>
            ) : (
              <div className="no-rooms-section">
                <h3 className="section-title">
                  <span className="title-icon">🚪</span>
                  Odalar
                </h3>
                <p>Bu kat için oda bilgisi bulunamadı.</p>
              </div>
            )}
          </div>

          {/* Sağ Taraf - Kroki */}
          <div className="kroki-panel">
            {floorImage ? (
              <div className="floor-viewer">
                <div className="floor-image-wrapper">
                  <img 
                    src={floorImage} 
                    alt={`${selectedFloor} kroki`}
                    className="floor-image-new"
                    style={{ position: 'relative', zIndex: 1 }}
                  />
                </div>
              </div>
            ) : (
              <div className="no-floor-plan">
                <div className="no-plan-content">
                  <span className="no-plan-icon">📋</span>
                  <h3>Kroki Bulunamadı</h3>
                  <p>Bu kat için kroki mevcut değil.</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Görsel Modal */}
      {imageModal.isOpen && (
        <div className="image-modal-overlay" onClick={closeImageModal}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="image-modal-header">
              <h3 className="image-modal-title">{imageModal.title}</h3>
              <button className="image-modal-close" onClick={closeImageModal}>
                ✕
              </button>
            </div>
            <div className="image-modal-body">
              <img 
                src={imageModal.imageUrl} 
                alt={imageModal.title}
                className="image-modal-image"
                onError={(e) => {
                  console.log('❌ PC MODAL OPTİMİZE EDİLMİŞ derslik görseli yüklenemedi (.png):', e.target.src);
                  // Optimize edilmiş görsel yüklenemezse önce .jpg dene, sonra eski görseli dene
                  const baseUrl = apiBaseUrl.replace('/api', '');
                  const baseFileName = imageModal.title
                    .toLowerCase()
                    .replace(/&/g, 've')
                    .replace(/[^a-z0-9çğıöşü]/g, '_')
                    .replace(/\//g, '_')
                    .replace(/_+/g, '_')
                    .replace(/^_|_$/g, '');
                  
                  // Önce optimize edilmiş .jpg dene
                  const optimizedJpgUrl = `${baseUrl}/static/room_images_optimized/${baseFileName}.jpg`;
                  console.log('🔄 PC MODAL OPTİMİZE EDİLMİŞ DERSLİK GÖRSELİ DENENİYOR (.jpg):', optimizedJpgUrl);
                  
                  // .jpg yüklenemezse eski görseli dene
                  const oldImage = new Image();
                  oldImage.onload = () => {
                    console.log('✅ PC MODAL ESKİ DERSLİK GÖRSELİ YÜKLENDİ:', oldImage.src);
                    e.target.src = oldImage.src;
                  };
                  oldImage.onerror = () => {
                    console.log('❌ PC MODAL ESKİ DERSLİK GÖRSELİ DE YÜKLENEMEDİ');
                    e.target.style.display = 'none';
                  };
                  oldImage.src = optimizedJpgUrl;
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BuildingDetail;
